import { render } from "./TimeSpeedDistance.vue?vue&type=template&id=67183974"
import script from "./TimeSpeedDistance.vue?vue&type=script&lang=js"
export * from "./TimeSpeedDistance.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__